import React from 'react'
import { connect } from 'react-redux'
import { Button, Card, Table, Tag, message } from 'antd'
import PageHeader from '@/components/PageHeader'
import Permission from '@/components/PermissionA5'
import { SelectC } from '@/i2antdV5'
import { renderPhoneStr, renderTextStr, formatDay } from '@/utils/renderUtils'
import { fetchJStoreList } from '@/redux/components/getJStoreListSlice'
import { fetchTuinaTherapistOnDuty } from '@/redux/tuina/therapistOnDutySlice'
import { TUINA_GENDER_OPTIONS, TUINA_THERAPIST_STATUS_OPTIONS } from '@/views/tuina/options'
import TherapistModal from './share/TherapistModal'
import TherapistDetailDrawer from './share/TherapistDetailDrawer'
import './Page.less'

const breadcrumbList = [
  { breadcrumbName: '按摩' },
  { breadcrumbName: '师傅' }
]

class TuinaTechniciansPage extends React.Component {
  didInitList = false

  componentDidMount () {
    this.props.fetchJStoreList({ query: {}, dataType: 'optionTuina' })
      .unwrap()
      .catch((err) => message.error(typeof err === 'string' ? err : '加载门店列表失败'))
  }

  componentDidUpdate (prevProps) {
    if (this.didInitList) return
    if (this.props.getJStoreList.fetching) return
    if (!prevProps.getJStoreList.fetching) return
    this.didInitList = true
    const options = this.props.getJStoreList.data
    const first = Array.isArray(options) && options[0]
    const query = {}
    if (first && first.id != null && first.id !== '') query.storeId = first.id
    this.fetchList(query)
  }

  fetchList = (formatQuery) => {
    this.props
      .fetchTuinaTherapistOnDuty({ query: formatQuery })
      .unwrap()
      .catch((err) => message.error(typeof err === 'string' ? err : '加载师傅失败'))
  }

  handleModalSuccess = () => {
    this.fetchList(this.props.therapistOnDuty.query)
  }

  storeName = (storeId) => {
    const options = this.props.getJStoreList.data
    if (!Array.isArray(options)) return storeId
    const row = options.find((item) => String(item.id) === String(storeId))
    return row ? row.value : storeId
  }

  getColumns = () => [
    {
      title: '师傅',
      key: 'who',
      width: 220,
      render: (_, record) => {
        const url = record.avatarUrl == null ? '' : String(record.avatarUrl).trim()
        const avatar = url
          ? <img className="tuina-tech-avatar" src={url} alt="" />
          : <span className="tuina-tech-avatar is-empty" />
        return (
          <TherapistDetailDrawer record={record}>
            <button type="button" className="tuina-tech-who" aria-label={`查看 ${record.name}`}>
              {avatar}
              <span className="tuina-tech-who-copy">
                <span className="tuina-tech-who-name">{renderTextStr(record.name)}</span>
                <span className="tuina-tech-who-no">{renderTextStr(record.therapistNo)}</span>
              </span>
            </button>
          </TherapistDetailDrawer>
        )
      }
    },
    {
      title: '门店',
      dataIndex: 'storeId',
      width: 140,
      render: (v) => renderTextStr(this.storeName(v))
    },
    {
      title: '手机号',
      dataIndex: 'phone',
      width: 140,
      render: (v) => renderPhoneStr(v)
    },
    {
      title: '性别',
      dataIndex: 'gender',
      width: 72,
      render: (v) => {
        const row = TUINA_GENDER_OPTIONS.find((item) => item.id === v || item.id === Number(v))
        return renderTextStr(row && row.value)
      }
    },
    {
      title: '简介',
      dataIndex: 'intro',
      ellipsis: true,
      render: (v) => renderTextStr(v)
    },
    {
      title: '状态',
      dataIndex: 'status',
      width: 88,
      render: (v) => {
        const row = TUINA_THERAPIST_STATUS_OPTIONS.find((item) => item.id === v)
        const text = (row && row.value) || v
        if (!text) return renderTextStr(text)
        return <Tag color={row && row.color}>{text}</Tag>
      }
    },
    {
      title: '入职时间',
      dataIndex: 'joinedAt',
      width: 120,
      render: (v) => formatDay(v)
    },
    {
      title: '操作',
      key: 'actions',
      width: 88,
      render: (_, record) => (
        <div className="tuina-tech-actions">
          <Permission rootPath="tuinaPage">
            <span pathitem={['technicians']} checkarray={['buttonCodes']}>
              <TherapistModal actType="edit" record={record} onSuccess={this.handleModalSuccess}>
                <Button type="link" aria-label={`改 ${record.name}`}>编辑</Button>
              </TherapistModal>
            </span>
          </Permission>
        </div>
      )
    }
  ]

  render () {
    const { therapistOnDuty, getJStoreList } = this.props
    const { fetching, query, data } = therapistOnDuty
    const list = Array.isArray(data) ? data : []
    const jStoreOptions = getJStoreList.data

    return (
      <div>
        <PageHeader title="师傅" breadcrumbList={breadcrumbList} />
        <div className="i2-container">
          <Card className="i2-card-page">
            <section className="i2-app-toolbar tuina-tech-toolbar">
              <div className="toolbar-filters">
                <SelectC
                  label="门店"
                  query={query}
                  searchKey="storeId"
                  options={jStoreOptions}
                  action={this.fetchList}
                  placeholder="全部"
                  modalProps={{ allowClear: true }}
                />
              </div>
              <div className="toolbar-btns">
                <Permission rootPath="tuinaPage">
                  <span pathitem={['technicians']} checkarray={['buttonCodes']}>
                    <TherapistModal actType="create" onSuccess={this.handleModalSuccess}>
                      <Button type="primary" size="large">新增师傅</Button>
                    </TherapistModal>
                  </span>
                </Permission>
              </div>
            </section>
            <Table
              className="tuina-tech-table"
              rowKey={(r) => String(r.id)}
              columns={this.getColumns()}
              dataSource={list}
              loading={fetching}
              pagination={false}
            />
          </Card>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  therapistOnDuty: state.tuina.therapistOnDuty,
  getJStoreList: state.components.getJStoreList
})

const mapDispatchToProps = {
  fetchTuinaTherapistOnDuty,
  fetchJStoreList
}

export default connect(mapStateToProps, mapDispatchToProps)(TuinaTechniciansPage)
